var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212529",
    d: "M5.807 17.943a.625.625 0 0 1 0-.885L12.865 10 5.807 2.943a.626.626 0 0 1 .885-.885l7.5 7.5a.626.626 0 0 1 0 .885l-7.5 7.5a.623.623 0 0 1-.885 0"
  })));
};
export default SvgChevronRight;